import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, useTheme } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../hooks/reduxHooks'
import { closeDialog, setSaveState } from '../services/redux/savestate/savestate-actions'
import { getDialogNavigationRoute, isDialogOpen } from '../services/redux/savestate/savestate-selectors'
import UnsavedChangesWarningImage from '../assets/images/unsavedChangesWarningImage.png'

const UnsavedChangesDialog: React.FC = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const theme = useTheme()

    const dialogOpen = useAppSelector(isDialogOpen)
    const destinationRoute = useAppSelector(getDialogNavigationRoute)

    const handleCloseDialog = () => {
        dispatch(closeDialog())
    }

    const handleNavigate = () => {
        dispatch(setSaveState(true))
        dispatch(closeDialog())
        if (destinationRoute === -1) navigate(-1)
        else navigate(destinationRoute)
    }

    return (
        <div>
            <Dialog open={dialogOpen} onClose={handleCloseDialog}>
                <img
                    src={UnsavedChangesWarningImage}
                    alt='unsavedChangesImage'
                    width={195}
                    style={{ margin: 'auto', marginTop: theme.spacing(3) }}
                />

                <DialogTitle textAlign='center'>Změny nejsou uloženy</DialogTitle>
                <DialogContent>
                    <DialogContentText>Data budou nenávratně ztracena.</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} autoFocus>
                        Zpět
                    </Button>
                    <Button onClick={handleNavigate} variant='contained'>
                        Neukládat
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default UnsavedChangesDialog
